import { createContext, ReactNode,  useContext, useEffect, useState } from "react";
import { api } from "../services/api";
import { socket } from "../services/socket";

interface User {
  id: string;
  name: string;
  messageLimit: number; 
  cpfCnpj?: string; 
  email?: string;
  password?: string;
  createdAt: Date;
  type: 'USER' | 'CLIENT';
  case: 1 | 2;
  token: string;
}
interface AuthContextData{
  user: User;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  hasPermission:(type:string) => boolean;
  updateUser:(userData: Omit<User, 'messageLimit'|'createdAt'|'token'|'type'|'case'>) => void;
}
interface AuthProviderProps {
  children: ReactNode;
}
export const AuthContext = createContext({} as AuthContextData);


function AuthProvider({ children }: AuthProviderProps) {
  const [user, setUser] = useState<User>({} as User);
  const [loading, setLoading] = useState(true);


  async function signIn(email: string, password: string) {
    try {
      setLoading(true);
      const userInfo = await api.post('/session', { email, password }).catch(error =>{
        throw new Error(
          error?.response?.data?.message
            ? error?.response?.data?.message
            : 'Não foi possível autenticar',
        );
      });
      api.defaults.headers.common.authorization = `Bearer ${userInfo.data.token}`;
      const userData = {
        ...userInfo.data.user,
        token: userInfo.data.token,
        type: 'USER'
      } as User;
      localStorage.setItem('@Info:user',  JSON.stringify(userData));
      setUser(userData);
      socket.emit('get_in_room',{
        room: userData.id,
        userId: userData.id
      })
    } catch (error: any) {
      throw new Error(
        error?.message
          ? error?.message
          : 'Não foi possível autenticar',
      );
    } finally {
      setLoading(false);
    }
  }
  async function signOut() {
    socket.emit('leave_room',{
      room: user.id,
      userId: user.id
    })
    setUser({} as User);
    localStorage.removeItem('@Info:user');
  }
  function hasPermission(type:string) {
    const findRole = type ? type.split(',').includes(user.type) : true;
    return findRole
  }
  async function loadUserStorageData() {
    const storage =localStorage.getItem('@Info:user');
    if (storage) {
      const userLogged = JSON.parse(storage) as User;
      api.defaults.headers.common.authorization = `Bearer ${userLogged.token}`;
      setUser(userLogged);
      socket.emit('get_in_room',{
        room: userLogged.id,
        userId: userLogged.id
      })
    }
   setLoading(false)
  }
  async function updateUser(userData: Omit<User, 'messageLimit'|'createdAt'|'token'|'type'|'case'>) {
  setUser({
    ...user,
    name: userData.name,
    email: userData.email

  })
  }
  useEffect(() => {
    loadUserStorageData();
  }, []);
  useEffect(() => {
    console.log('user', user);
  }, [user]);
return(
  <AuthContext.Provider value={{
    loading,
    user,
    signIn,
    signOut,
    hasPermission,
    updateUser
  }}>
    {children}
  </AuthContext.Provider>
)
}


function useAuth() {
  const context = useContext(AuthContext);
  return context;
}

export { AuthProvider, useAuth };